import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { MessageService } from '@services/message/message.service';

@Component({
  selector: 'app-email-change-confirmation',
  templateUrl: './email-change-confirmation.component.html',
  styleUrls: ['./email-change-confirmation.component.scss']
})
export class EmailChangeConfirmationComponent implements OnInit {

  @ViewChild('successMessage') successMessage: TemplateRef<any>;

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, public messageService: MessageService) { }

  ngOnInit(): void {
    this.confirmEmail();
  }

  confirmEmail() {
    const token = this.route.snapshot.queryParams['token'];
    const email = this.route.snapshot.queryParams['email'];
    const newEmail = this.route.snapshot.queryParams['newEmail'];

    this.authenticationService.confirmEmailChange(token, email, newEmail)
      .subscribe(_ => {
        this.messageService.setSuccess(this.successMessage);
      },
        error => {
          this.messageService.setError(error);
        })
  }
}
